var _ = require("underscore");
var env = require('./env.js');

var r = _.map(_.range(83), function (x) {
    return {
        name: "Region " + x,
        id: x
    };
});

var s = _.map(_.range(40), function (x) {
    return {
        name: "Sport " + x,
        id: x
    };
});

function findCompanies(search, $http) {
    var params = {q: search};
    return $http.get(env.origin + '/api/companies/find', {params: params})
}

function findRegions($http) {
    return $http.get(env.origin + '/api/dict_regions/find')
    //return r;
}

function findSports($http) {
    return $http.get(env.origin + '/api/dict_sports/find')
    //return s;
}

module.exports = {
    findCompanies: findCompanies,
    findRegions: findRegions,
    findSports: findSports
};



/** WEBPACK FOOTER **
 ** ./_services/commonDataSvc.js
 **/